async function fetchRequest(url, method, body = null) {
  try {
    const options = {
      method,
      headers: {
        "Content-Type": "application/json",
      },
    };
    if (body) options.body = JSON.stringify(body);
    const response = await fetch(url, options);
    if (!response.ok) {
      const errorMessage = `Error: ${response.status} - ${response.statusText}`;
      throw new Error(errorMessage);
    }
    return await response.json();
  } catch (error) {
    console.error(`Request failed for ${method} ${url}:`, error);
    throw error;
  }
}

// Only include the updateCart function, as needed for attributes
function updateCart(change) {
  if (
    !change ||
    typeof change.id === "undefined" ||
    typeof change.quantity !== "number"
  ) {
    // For attributes update, Shopify expects an object with note or attributes, so skip this validation
    // Accept any object for attributes update
    return fetchRequest("/cart/update.js", "POST", change);
  }
  return fetchRequest("/cart/change.js", "POST", change);
}

function updateCartAttributes(attributes) {
  // Accepts either note or attributes object
  return updateCart(attributes);
}

window.updateCartAttributes = updateCartAttributes;

(function initializeSearchEstheticianAccessibility() {
  if (window.searchEstheticianAccessibilityInitialized) return;
  window.searchEstheticianAccessibilityInitialized = true;

  function improveSearchAccessibility() {
    const searchBox = document.getElementById("search-box");
    const suggestionBox = document.getElementById("suggestion-box");
    if (!searchBox || !suggestionBox) return;

    searchBox.setAttribute("aria-controls", suggestionBox.id);
    searchBox.removeAttribute("aria-owns");
    suggestionBox.setAttribute("role", "listbox");
    suggestionBox.setAttribute(
      "aria-label",
      "Acne Expert or company suggestions"
    );
  }

  function startSearchAccessibilityObserver() {
    improveSearchAccessibility();

    const observer = new MutationObserver(improveSearchAccessibility);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      startSearchAccessibilityObserver,
      { once: true }
    );
  } else {
    startSearchAccessibilityObserver();
  }
})();
